import { styled } from 'styled-components';
import { Pagination } from 'antd';

export const FooterWrap = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

// Create a styled Pagination component
export const StyledPagination = styled(Pagination)`
  //code may be used in future
  /* Style the pagination item (page number) */
  .ant-pagination-item {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  .ant-pagination-prev:hover,
  .ant-pagination-next:hover {
    background-color: #f5f5f5;
  }
  .ant-pagination-total-text {
    color: white;
  }
`;
